<ng-container [formGroup]="form()">
  <ion-textarea
    formControlName="reason"
    label="Razón del cambio"
    labelPlacement="floating"
    placeholder="Indica el motivo de este cambio..."
    fill="outline"
    mode="md"
    errorText="Indica el motivo del cambio"
    [autoGrow]="true"
    [counter]="true"
    maxlength="500"
    rows="3"
  ></ion-textarea>
</ng-container>
